import { useCallback } from "react"
import { useKioskConfig } from "providers/venue/modules/data/kiosk-config/useKioskConfig"
import { useInterval } from "hooks/useInterval"

// Ping the uptime monitor on this cadence to report that the kiosk is alive.
const HEARTBEAT_INTERVAL = 1000 * 60 // 60 seconds

export const useUptimeHeartbeat = () => {
  const { kioskConfig } = useKioskConfig()
  const heartbeatUrl = kioskConfig?.source?.uptime_heartbeat_url
  const sendHeartbeat = useCallback(() => {
    if (!heartbeatUrl) return
    // Fire-and-forget: heartbeat endpoints are cross-origin and need no response.
    fetch(heartbeatUrl, { method: "GET", mode: "no-cors" }).catch(() => {})
  }, [heartbeatUrl])

  useInterval({
    callback: sendHeartbeat,
    delay: HEARTBEAT_INTERVAL,
    options: { enable: Boolean(heartbeatUrl) },
  })
}
